<template>
    <div v-if="activeIndex">
        <div v-for="item in guideData_" :key="item.id">
            <div v-if="item.id === activeIndex" class="guide-content">
                <div class="guide-child">
                    <div class="guide-shadow" :style="item.shadowCoord"></div>
                    <div class="guide-item" :style="item.textCoord">
                        <div class="bg-item">
                            <h4 style="margin: 0; color: #1F6EEF; font-size: 16px;">{{ item.title }}</h4>
                            <div style="margin-top: 20px" class="text" v-if="item.text">{{ item.text }}</div>
                            <div class="text" v-for="(text, index) in item.list" :key="index">{{ text }}</div>
                        </div>
                        <div>
                            <gj-button @click="pre" v-if="item.preBtn" style="margin-top: 12px">{{ item.preBtn }}</gj-button>
                            <gj-button @click="next(item)" v-if="item.nextBtn" type="primary" style="margin-top: 12px">{{ item.nextBtn }}</gj-button>
                            <gj-button @click="close(item)" v-if="item.closeBtn" type="primary" style="margin-top: 12px">{{ item.closeBtn }}</gj-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { saveOrUpdate } from '@/api/message';
export default {
    name: 'ErpWebGuide',
    props: {
        guideData: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            activeIndex: null, //当前激活的ID
            guideData_: this.guideData
        };
    },
    methods: {
        start(id) {
            this.guideData_.forEach((item, index) => {
                item?.computing && this.computing(this, index, item.computing);
            })
            this.activeIndex = id || this.guideData_[0].id;
        },
        async next(item) {
            if (item.nextFn) {
                await item.nextFn(this)
            }
            this.activeIndex = this.activeIndex + 1;
        },
        pre() {
            this.activeIndex = this.activeIndex - 1;
        },
        close(item) { // item.closeParams
            const params = {
                module: "PERSONCENTER",
                name: item.closeParams.name,
                value: 'hide',
                description: item.closeParams.description,
                status: 0
            }
            saveOrUpdate(params).then(res => {
                this.activeIndex = null;
            })
        },

        // 计算坐标 用于适配在表格当中使用
        computing(_this, index, computing) { // _this 当前实例   tableClass表格元素的class
            // 当前的数据
            const current = _this.guideData_[index];
            // 获取其父级的表格的高度
            const tableInfo = document.querySelector(computing.tableClass).getBoundingClientRect();
            // 获取当前元素的坐标信息
            const info = document.querySelector(computing.elClass).getBoundingClientRect();
            // 操作剪切部分的坐标数据
            current.shadowCoord = {
                top: `${info.top}px`,
                left: `${info.left}px`,
                width: `${info.width}px`,
                height: `${info.height + tableInfo.height - 88}px`, // 由于获取到的高度是计算之前的，所以需要减去48
            }
            // 操作text的坐标数据
            current.textCoord = {
                top: `${info.top}px`,
                left: `${info.left + (computing.place === 'left' ? -360 : (info.width + 20))}px`,
                width: '340px',
            }
        }
    },
};
</script>

<style lang="scss" scoped>
    // 底板
    .guide-content{
        position: fixed;
        left: 0;
        top: 0;
        z-index: 2000;
        width: 100vw;
        height: 100vh;
        font-family: 'PingFang SC';
        font-style: normal;
    }
    // 第一步
    .guide-child{
        height: 100%;
        width: 100%;
        position: relative;
        .guide-shadow{
            position: absolute;
            box-shadow: rgba(0, 0, 0, 0.39) 0px 0px 0px 4000px;
        }
        .guide-item{
            position: absolute;
            display: flex;
            flex-direction: column;
            align-items: center;
            .bg-item{
                width: 100%;
                box-sizing: border-box;
                background: white;
                padding: 16px;
                border-radius: 10px;
            }
            .text{
                font-size: 12px;
                line-height: 18px;
            }
            .text + .text{
                margin-top: 12px;
            }
        }
    }
    
</style>